import { MakeAPredictionButton } from "components/public/ListingsPage/components/MakeAPredictionButton"

export const FloatingMakeAPredictionButton = () => {
  return <div className="btn-float-make-prediction d-block d-md-none" style={{zIndex: 100}}><MakeAPredictionButton /></div>
}
